export default function(x) {
  if (Math.abs(x) > 1) {
    x = (x > 1) ? 1 : -1;
  }
  return Math.asin(x);
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/asinz.js
// module id = UKTL
// module chunks = 0